/*
 * Public API Surface of ngx-duration-picker
 */

export * from './lib/duration-picker.component';
export * from './lib/duration-picker.module';
